import {computed, observable} from "mobx";
import {IndicadorService} from "../../../services";
import {getMensagemDeErro} from "../../../utils/functions";

export default class QuantidadePercentualMOTsFaixaRemuneracaoStore {
    @observable erro;
    @observable carregando;
    @observable dados;
    @observable activeTab;

    constructor() {
        this.indicadorService = new IndicadorService();

        this.activeTab = '1';
    }

    filtrar = (filtro) => {
        this.carregando = true;
        this.erro = null;

        this.indicadorService.findQuantidadePercentualMOTsFaixaRemuneracao(filtro).then(response => {
            if(response.data) {
                this.dados = [{
                    nome: `<${response.data.prctMin}%`,
                    "Quantidade": response.data.lessThanPrctMin
                }, {
                    nome: `=${response.data.prctMin}%`,
                    "Quantidade": response.data.equalsPrctMin
                }, {
                    nome: `>${response.data.prctMin}% <=${response.data.prctMinAvalAR}%`,
                    "Quantidade": response.data.betweenPrctMinAndPrctMinAvalAR
                }, {
                    nome: `>${response.data.prctMinAvalAR}% <=${response.data.prctRgl}%`,
                    "Quantidade": response.data.betweenPrctMinAvalARAndPrctRgl
                }, {
                    nome: `>${response.data.prctRgl}%`,
                    "Quantidade": response.data.moreThanPrctRgl
                }];
            } else {
                this.dados = [];
            }

            this.carregando = false;
        }).catch(error => {
            this.erro = getMensagemDeErro(error);
            this.carregando = false;
        });
    }

    toggle = (tab) => {
        if (this.activeTab !== tab) {
            this.activeTab = tab;
        }
    }
}
